import {GoalBit} from '@/domain';

type ContextMap = Record<string, number>;
export type EventDef<Context extends ContextMap = never> = {
  readonly context: Context;
};

function context(): EventDef;
function context<const Context extends ContextMap>(
  values: Context
): EventDef<Context>;
function context(values?: ContextMap) {
  return {context: values};
}

export const SUPPORT_EVENTS = {
  'web.landing_page_passed': context(),
  'web.login_screen_loaded': context(),
  'web.email_sign_up_button_clicked': context(),
  'web.google_continue_sign_up_passed': context(),
  'web.apple_continue_sign_up_passed': context(),
  'web.oauth_screen_passed': context(),
  'web.email_enter_screen_passed': context(),
  'web.code_screen_passed': context(),
  'web.check_email_screen_loaded': context(),
  'web.name_screen_passed': context(),
  'web.dob_screen_passed': context(),
  'web.gender_screen_passed': context(),
  'web.looking_for_screen_passed': context(),
  'web.goal_screen_passed': context({
    chat: GoalBit.CHAT,
    networking: GoalBit.NETWORKING,
    learn: GoalBit.LEARN,
    travel: GoalBit.TRAVEL,
    relationship: GoalBit.RELATIONSHIP,
    marriage: GoalBit.MARRIAGE,
  }),
  'web.interests_screen_passed': context(),
  'web.height_screen_passed': context(),
  'web.weight_screen_passed': context(),
  'web.sexual_orientation_screen_passed': context(),
  'web.star_sign_screen_passed': context(),
  'web.sport_screen_passed': context(),
  'web.education_level_screen_passed': context(),
  'web.marital_status_screen_passed': context(),
  'web.kids_screen_passed': context(),
  'web.drink_screen_passed': context(),
  'web.smoke_screen_passed': context(),
  'web.pets_screen_passed': context(),
  'web.religion_screen_passed': context(),
  'web.value_screen_passed': context(),
  'web.about_screen_passed': context(),
  'web.photo_screen_passed': context(),
  'web.sign_in': context({apple: 1, google: 2, email: 3}),
  'web.phone_screen_passed': context(),
  'web.demo_app_passed': context(),
  'match.link.opened': context(),
  'web.sign_up_button_clicked': context({
    apple: 1,
    google: 2,
    email: 3,
  }),
  'web.real_couples_passed': context(),
  'web.payment.paywall_opened': context(),
  'web.payment.plan_selected': context({
    0: 0,
    1: 1,
    2: 2,
    3: 3,
  }),
  'web.payment.checkout_opened': context(),
  'web.payment.payment_started': context({
    apple: 1,
    google: 2,
    card: 3,
  }),
  'web.payment.payment_result': context({
    success: 1,
    failed: 2,
  }),
};
